import { isLocalizedObject } from './localizeObject';

export const defaultIdAccessor = <Datum>(obj: Datum) => {
  if (isLocalizedObject(obj)) {
    // eslint-disable-next-line no-underscore-dangle
    return obj.__id;
  }
  throw new Error('Expected localized object. Missing id accessor.');
};

export const isDefaultIdAccessor = (accessor: unknown) => accessor === defaultIdAccessor;
